import { EditableSection, SectionSummary } from "../types";
import { scaffoldEdit } from "common/scaffolding/reducers/scaffoldEdit";

export enum TypeKeys {
    FETCH_BEGIN = "TABLE_SECTION/FETCH_EDITABLE_BEGIN",
    FETCH_SUCCESS = "TABLE_SECTION/FETCH_EDITABLE_SUCCESS",
    FETCH_FAILURE = "TABLE_SECTION/FETCH_EDITABLE_FAILURE",

    SAVE_BEGIN = "TABLE_SECTION/SAVE_EDITABLE_BEGIN",
    SAVE_SUCCESS = "TABLE_SECTION/SAVE__EDITABLE_SUCCESS",
    SAVE_FAILURE = "TABLE_SECTION/SAVE_EDITABLE_FAILURE",
}

const edit = scaffoldEdit<EditableSection, SectionSummary, typeof TypeKeys>(TypeKeys);
const { createAction, reducer } = edit;

export type State = ReturnType<typeof edit.reducer>;
export { createAction, reducer };

export type SavedAction = ReturnType<typeof createAction.saved>;
